import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'src/app/service/shared/shared.service';
import { HttpService } from 'src/app/service/http/http.service';
import { GenericService } from 'src/app/services/genericService/generic.service';
import { Config } from 'src/app/app-constant';
import { DwmGenericServiceService, TableState } from '../../_DWM-Generic-Services/generic-service.service';
import { GetCompanyAndUsersData } from 'src/app/services/get-company-and-users-data/get-company-and-users-data.service';
import { AllPopupModalExecutionServiceService } from 'src/app/shared/services/all-popup-modal-execution-service.service';

@Component({
  selector: 'app-approve-or-reject-skip-day',
  templateUrl: './approve-or-reject-skip-day.component.html',
  styleUrls: ['./approve-or-reject-skip-day.component.scss']
})
export class ApproveOrRejectSkipDayComponent implements OnInit {
  needManagerComment = false;
  addManagerComment = '';
  loggedInUserCompanyID: any = null;
  loggedInUserId: any = null;

  constructor(
    private matDialogRef: MatDialogRef<ApproveOrRejectSkipDayComponent>,
    @Inject(MAT_DIALOG_DATA) public matDialogData: any,
    public dwmGenericServiceService: DwmGenericServiceService,
    public sharedService: SharedService,
    private httpService: HttpService,
    private config: Config,
    public dialog: MatDialog,
    private toastr: ToastrService,
    public genericService: GenericService,
    private getCompanyAndUsersData: GetCompanyAndUsersData,
    private allPopupModalExecutionServiceService: AllPopupModalExecutionServiceService
  ) {}

  ngOnInit() {
    this.loggedInUserCompanyID = this.getCompanyAndUsersData.loggedInUserCompanyID;
    this.loggedInUserId = this.getCompanyAndUsersData.loggedInUserId;
  }

  filterAndPayloadData(data: any) {
    return {
      id: data?.id,
      transactionId: data?.transactionId || '',
      userId: data?.userId || '',
      managerId: data?.managerId || this.loggedInUserId,
      companyId: data?.companyId || '',
      dwmDate: data?.dwmDate || '',
      reason: data?.reason || '',
      managerComment: data?.managerComment || ''
    };
  }

  /* Filters */
  approveOrRejectSkipDayCall(status: boolean) {
    this.needManagerComment = false;
    if (!status && !this.addManagerComment?.length) {
      this.needManagerComment = true;
      this.toastr.error('Please add reason to reject');
      return;
    }

    const payload = this.matDialogData?.data?.map((task: any) => ({ ...this.filterAndPayloadData(task), isSkipped: status, managerComment: this.addManagerComment }));

    this.allPopupModalExecutionServiceService
      .confirmationPopupComponentExe({ msg: `Are you sure you want to ${status ? 'Approve' : 'Reject'} the skip day for ${this.matDialogData.userName} on ${this.matDialogData.date}` })
      .afterClosed()
      .subscribe((confirmed: any) => {
        if (confirmed) {
          this.approveOrRejectApiCall(payload);
        }
      });
  }

  approveOrRejectApiCall(payload: any) {
    this.httpService.callPostService(this.config.dwmSkipDay, payload).subscribe({
      next: (data: any) => {
        if (data?.status) {
          this.matDialogRef.close(true);
          this.toastr.success(data.message);
        } else {
          this.toastr.error(data.message);
        }
      },
      error: err => {
        this.toastr.error(err.message);
      }
    });
  }
}
